import { CustomOutlinedInput } from "./OutlinedInput";

export default CustomOutlinedInput;
